/**
 * 電子發票證明聯「左側 QR Code」解析（財政部電子發票 QR Code 規格，前段為固定長度）：
 * 1–10 發票號碼｜11–17 開立日期（民國 yyyMMdd）｜18–21 隨機碼｜
 * 22–29 未稅金額（16 進位）｜30–37 含稅總額（16 進位）｜之後為統編、加密驗證等。
 * 右側 QR Code（以 ** 開頭，品項明細）不含上述欄位，不支援。
 */
const EINVOICE_QR_MIN_LENGTH = 37;
const INVOICE_NO_PATTERN = /^[A-Z]{2}\d{8}$/;
const ROC_DATE_PATTERN = /^\d{7}$/;
const HEX_AMOUNT_PATTERN = /^[0-9A-Fa-f]{8}$/;
const ROC_YEAR_OFFSET = 1911;

function rocDateToIso(rocDate) {
  if (!ROC_DATE_PATTERN.test(rocDate)) {
    return null;
  }
  const year = Number(rocDate.slice(0, 3)) + ROC_YEAR_OFFSET;
  const month = Number(rocDate.slice(3, 5));
  const day = Number(rocDate.slice(5, 7));
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year
    || date.getUTCMonth() !== month - 1
    || date.getUTCDate() !== day
  ) {
    return null;
  }
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

/**
 * @param {string} rawText QR Code 解碼後的文字
 * @returns {{ voucherNo: string, voucherDate: string, totalAmount: number } | null}
 *   無法辨識回 null
 */
export function parseEinvoiceQr(rawText) {
  const text = String(rawText ?? '').trim();
  if (text.length < EINVOICE_QR_MIN_LENGTH) {
    return null;
  }

  const voucherNo = text.slice(0, 10).toUpperCase();
  const voucherDate = rocDateToIso(text.slice(10, 17));
  const totalHex = text.slice(29, 37);
  if (!INVOICE_NO_PATTERN.test(voucherNo) || !voucherDate || !HEX_AMOUNT_PATTERN.test(totalHex)) {
    return null;
  }

  return {
    voucherNo,
    voucherDate,
    totalAmount: Number.parseInt(totalHex, 16),
  };
}
